/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { LftCountdownAction, LftCountdownActionId, getIconForActionId } from '../shared';

export const LftCountdownAnalystActionCard: LftCountdownAction = {
    id: LftCountdownActionId.AnalystDialog,
    primaryContent: strings.getString('lftSidePaneTrialCountDownAnalystCardText'),
    icon: getIconForActionId(LftCountdownActionId.AnalystDialog),
    onClick: () => logger.logInfo('LaunchAnalystDialog', 'User clicked on analyst card.')
};
